import { Userpilot } from 'userpilot';
import { useCallback } from 'react';

type UserPilotEvents =
  | 'proposal_sent'
  | 'Clicked NOT ACCURATE on auto-populated revenue data'
  | 'Clicked VALIDATE on auto-populated revenue data';

type UserPilotPrimitives = string | number | boolean | null;
type MetaPayload = Record<string, UserPilotPrimitives>;

export interface UserPilotPayload {
  event: UserPilotEvents;
  metadata?: MetaPayload;
}

export function useUserPilot() {
  const handleTrackEvent = useCallback((dto: UserPilotPayload) => {
    const { event, metadata } = dto;

    Userpilot.track(event, metadata);
  }, []);

  return {
    handleTrackEvent,
  };
}
